import type { ValidateRoutingNumber } from '@corp/serializers'
import { recipientGifts } from '@consumer/api'

interface ResponseData {
  success?: 'success'
  error?: string
  message?: string
}

interface LookupResult extends ResponseData {
  status?: string
  redirectUrl: string
}

export async function giftCodeLookup (activationCode: string, recaptchaToken: string) {
  try {
    return await recipientGifts.giftCodeLookup<LookupResult>({ data: { activationCode, recaptchaToken } })
  }
  catch (error: any) {
    throw new Error(error.response.data.message)
  }
}

export async function validateBankRoutingNumber (routingNumber: string) {
  try {
    return await recipientGifts.validateBankRoutingNumber<ValidateRoutingNumber>({ data: { routingNumber } })
  }
  catch (error: any) {
    throw new Error(error.response.data.message)
  }
}

export async function validateBankAccountNumber (routingNumber: string, accountNumber: string) {
  try {
    return await recipientGifts.validateBankAccountNumber({ data: { routingNumber, accountNumber } })
  }
  catch (error: any) {
    throw new Error(error.response.data.message)
  }
}
